import SCOOTER_HOME_BANNER from 'assets/images/scooter/img-scooter-home-banner.png'
import { SCOOTER_TYPE_INFO } from 'assets/json/scooterInfo.js'
import ScooterTypeSwiper from '../../components/swiper/ScooterTypeSwiper'
import ScooterMainDesc from './ScooterMainDesc'
import './ScooterMain.scss'

/**
 * @file 스마트 스쿠터 main 화면
 */
function ScooterMain() {
    return (
        <>
            <div className="motors-wrapper">
                <button className="motor-btn next" />
                <button className="motor-btn prev" />
                <ScooterTypeSwiper />
            </div>
            <div className="scooter-one" style={{ backgroundImage: 'url(' + SCOOTER_HOME_BANNER + ')' }}>
                <div className="text-box">
                    <div className="sub">혁신적인 디자인</div>
                    <div className="t1">독보적인 기술력</div>
                    {/* <div className="des">
                        혁신적인 디자인과 기술력은 <br />
                        경험하지 못한 새로운 라이딩 경험을 제공합니다.
                    </div> */}
                </div>
            </div>
            <div>
                <ScooterMainDesc />
            </div>
            <div className="motors-last">
                <div>
                    <div className="motor-link-wrap">
                        <div className="sub">{SCOOTER_TYPE_INFO[0].name}</div>
                        <div className="t1">{SCOOTER_TYPE_INFO[0].sub}</div>
                        <a className="link" href={SCOOTER_TYPE_INFO[0].url}>
                            {'더 알아보기  >'}
                        </a>
                        <div className="img" style={{ backgroundImage: `url(${SCOOTER_TYPE_INFO[0].imgUrl})` }} />
                    </div>
                    <div className="motor-link-wrap">
                        <div className="sub">{SCOOTER_TYPE_INFO[1].name}</div>
                        <div className="t1">{SCOOTER_TYPE_INFO[1].sub}</div>
                        <a className="link" href={SCOOTER_TYPE_INFO[1].url}>
                            {'더 알아보기  >'}
                        </a>
                        <div className="img" style={{ backgroundImage: `url(${SCOOTER_TYPE_INFO[1].imgUrl})` }} />
                    </div>
                </div>
                <div>
                    <div className="motor-link-wrap">
                        <div className="sub">{SCOOTER_TYPE_INFO[2].name}</div>
                        <div className="t1">{SCOOTER_TYPE_INFO[2].sub}</div>
                        <a className="link" href={SCOOTER_TYPE_INFO[2].url}>
                            {'더 알아보기  >'}
                        </a>
                        <div className="img" style={{ backgroundImage: `url(${SCOOTER_TYPE_INFO[2].imgUrl})` }} />
                    </div>
                    <div className="motor-link-wrap">
                        <div className="sub">{SCOOTER_TYPE_INFO[3].name}</div>
                        <div className="t1">{SCOOTER_TYPE_INFO[3].sub}</div>
                        <a className="link" href={SCOOTER_TYPE_INFO[3].url}>
                            {'더 알아보기  >'}
                        </a>
                        <div className="img" style={{ backgroundImage: `url(${SCOOTER_TYPE_INFO[3].imgUrl})` }} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ScooterMain
